export default {
  data() {
    return {
      list: [],
      visible: false,
    };
  },
  methods: {
    open(list) {
      this.visible = true;
      this.list = list;
    },
  },
};
